import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ThirdAscensionChatEntrance.module.css";
function ThirdAscensionChatEntrance() {
  useEffect(() => {
    localStorage.setItem(
      "selectedEventName",
      window.location.href.split("//")[1].split("/")[1]
    );

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}projects/getprojectbypath`, {
        path: window.location.href,
      })
      .then((res) => {
        if (res.data._id !== undefined) {
          axios
            .post(
              `${process.env.REACT_APP_SERVER_URL}stats/setpage/chatroomEntrance`,
              {
                id: res.data._id,
              }
            )
            .then((res) => {});
        }
      });
  }, []);
  const history = useNavigate();
  return (
    <div>
      <div
        className={
          styles["mentor-card-screen-background"] + " breakRoom-container-fluid"
        }
      >
        <div className={styles["mask"]}></div>
        <div
          className='row asc-cards-flip-container'
          style={{ margin: "0", padding: "0", overflowY: "auto" }}
        >
          <div
            className={styles["btn-back-envirtual-container"] + " col-md-12"}
            onClick={() => {
              history("/asc3/hall");
            }}
          >
            <img src='/assets/back-btn.svg' className={styles["ddl"]}></img>
            <label className={styles["back-btn-label"]}>Back</label>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
            className='col-md-12 col-xs-12  '
          >
            <div className='row' style={{ margin: "0.5rem 0rem" }}>
              <div className='col-md-12 mb-3'>
                <span className={styles["title"]}>Chat room</span>
              </div>
              <div className='col-md-12 mb-5'>
                <span className={styles["sub-title"]}>
                  Are you ready to connect over some interesting topics?
                </span>
              </div>
              <div className='col-md-12 mt-2 mb-5'>
                <button
                  className={styles["btn-styling"]}
                  onClick={() => {
                    history("/asc3/chatrooms");
                  }}
                >
                  Discover Chat Room
                </button>
              </div>
              <div className='col-md-12'>
                <img src='/assets/thirdAscension/Chat.svg'></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThirdAscensionChatEntrance;
